import {connect} from 'react-redux';
import KioskOrderForm from './KioskOrderForm';
import {
  kioskNotesSelector, 
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import {isUploadInProgressSelector} from '../../selectors/uploadSelectors';
import {getConfigValue} from '../../reducers/configReducer';
import {
  secondaryColor
} from '../../config/const';

const mapStateToProps = state => ({
  fields: kioskNotesSelector(state),
  isUploadInProgress: isUploadInProgressSelector(state),
  isPaymentKiosk: isPaymentKioskSelector(state),
  secondaryColor: getConfigValue(secondaryColor, state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (formData) => ownProps.onSubmit(formData),
  onClose: () => ownProps.onClose()
});

export default connect(mapStateToProps, mapDispatchToProps)(KioskOrderForm);



// WEBPACK FOOTER //
// ./src/components/KioskOrderModal/KioskOrderFormContainer.js